module.exports = __webpack_public_path__ + "static/media/reso.e8bd3203.png";